import {
  Scale,
  Syringe,
  Bug,
  Pill,
  HeartPulse,
  Stethoscope,
  FileText,
} from 'lucide-react';
import { HEALTH_RECORD_TYPES } from '../../../config/constants';

/**
 * Chips para elegir el tipo de observación. Cada tipo activa campos
 * opcionales en el form (peso, producto, etc).
 */

export const TYPE_META = {
  [HEALTH_RECORD_TYPES.WEIGHT]:     { icon: Scale,       label: 'Peso',        className: 'text-emerald-700 bg-emerald-50' },
  [HEALTH_RECORD_TYPES.VACCINE]:    { icon: Syringe,     label: 'Vacuna',      className: 'text-sky-700 bg-sky-50' },
  [HEALTH_RECORD_TYPES.DEWORMING]:  { icon: Bug,         label: 'Antiparásito', className: 'text-amber-700 bg-amber-50' },
  [HEALTH_RECORD_TYPES.MEDICATION]: { icon: Pill,        label: 'Medicación',  className: 'text-purple-700 bg-purple-50' },
  [HEALTH_RECORD_TYPES.INJURY]:     { icon: HeartPulse,  label: 'Lesión',      className: 'text-rose-700 bg-rose-50' },
  [HEALTH_RECORD_TYPES.CHECKUP]:    { icon: Stethoscope, label: 'Control',     className: 'text-brand-700 bg-brand-50' },
  [HEALTH_RECORD_TYPES.NOTE]:       { icon: FileText,    label: 'Nota',        className: 'text-slate-700 bg-slate-100' },
};

const TYPE_OPTIONS = Object.entries(TYPE_META).map(([value, meta]) => ({
  value,
  icon: meta.icon,
  label: meta.label,
}));

const HealthRecordTypeChips = ({ value, onChange, disabled = false }) => {
  return (
    <div className="grid grid-cols-3 gap-2 sm:grid-cols-4">
      {TYPE_OPTIONS.map(({ value: v, icon: Icon, label }) => {
        const active = value === v;
        return (
          <button
            key={v}
            type="button"
            onClick={() => onChange(v)}
            disabled={disabled}
            className={[
              'flex flex-col items-center gap-1 rounded-xl border px-2 py-2.5 text-xs font-medium transition-colors',
              active
                ? 'border-brand-500 bg-brand-50 text-brand-800'
                : 'border-slate-200 bg-white text-slate-700 hover:bg-slate-50',
              disabled ? 'cursor-not-allowed opacity-60' : '',
            ].join(' ')}
          >
            <Icon className="h-5 w-5" aria-hidden="true" />
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default HealthRecordTypeChips;
